import React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Enquire from "./Enquire/Enquire";
import Work from "./Work/Work";
import "./talk.scss";
import { FormattedMessage } from "react-intl";
const Talk = () => {
  return (
    <div className="contact-talk">
      <Tabs>
        <TabList>
          <Tab>
            <FormattedMessage
              id="WithUs"
              defaultMessage="Work with us"
            />
            <div className="line"></div>
          </Tab>
          <Tab>
            <FormattedMessage
              id="General"
              defaultMessage="General Enquiries"
            />
            <div className="line"></div>
          </Tab>
        </TabList>
        <TabPanel>
          <Work />
        </TabPanel>
        <TabPanel>
          <Enquire />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default Talk;
